module.exports = __webpack_public_path__ + "img/KK0040C-PX.935fce77.jpg";